import { type PaylaodValidateEmailType } from '~~/stores/user/types'
import { useUserStore } from '~~/stores/user'
import { useMessageStore } from '~~/stores/message'
import { useAuthStore } from '~~/stores/auth'

const useFetch = () => {
  const route = useRoute()
  const router = useRouter()

  const checkHasParams = () => {
    const listOfQuery = ['token', 'oldEmail', 'newEmail']
    const queryKeys = Object.keys(route.query)
    listOfQuery.forEach((key) => {
      if (!queryKeys.includes(key)) {
        router.replace('/')
      }
    })
  }

  const userStore = useUserStore()
  const messageStore = useMessageStore()
  const authStore = useAuthStore()

  const isLoggedIn = computed(() => authStore.state.isLoggedIn)

  const confirmNewEmail = () => {
    userStore.validateUserEmail({
      payload: route.query,
      resolve: () => {
        messageStore.triggerMessage({
          type: 'success',
          body: 'Email berhasil diubah'
        })

        if (isLoggedIn.value) {
          router.push('/user')
        } else {
          router.push('/')
        }
      }
    })
  }

  return {
    checkHasParams,
    confirmNewEmail
  }
}

export default useFetch
